type LogoFooterShieldProps = {
  className?: string;
};

export const LogoFooterShield = ({
  className,
  ...props
}: LogoFooterShieldProps) => (
  <svg
    width="20"
    height="21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <title>Simply Business Shield logo</title>
    <g fill="#F3F3F3">
      <path d="M2.5 5.42188C2.46094 7.14062 2.77344 9.60156 3.78906 12.0234C4.92188 14.5625 6.79688 17.0234 10 18.4688C13.1641 17.0234 15.0391 14.5625 16.1719 12.0234C17.2266 9.60156 17.5391 7.14062 17.5 5.42188L10 2.53125L2.5 5.42188ZM19.3359 4.91406C19.4531 6.86719 19.1406 9.875 17.8906 12.7656C16.6016 15.7344 14.3359 18.625 10.4688 20.3047L10 20.5L9.49219 20.3047C5.625 18.625 3.35938 15.7344 2.07031 12.7656C0.820312 9.875 0.507812 6.86719 0.625 4.91406L0.664062 4.13281L1.40625 3.82031L9.53125 0.695312L10 0.5L10.4297 0.695312L18.5547 3.82031L19.2969 4.13281L19.3359 4.91406ZM14.4141 8.66406L9.41406 13.6641L8.75 14.3281L8.08594 13.6641L5.58594 11.1641L4.92188 10.5L6.25 9.21094L6.91406 9.875L8.75 11.7109L13.0859 7.375L13.75 6.71094L15.0781 8L14.4141 8.66406Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V21H0z" />
      </clipPath>
    </defs>
  </svg>
);
